@use "@fukuri-admins/ui/layout" as *;

.form {
  max-width: 564px;
}

// フォームタイトル（ClientContractTermCreate と同パターン）
.formTitle {
  @include typography("Jp/20_W6");
  color: text("High");
}

.selectOption {
  display: flex;
  @include typography('Jp/14_W3');

  &__name {
    color: text('High');
  }

  &__code {
    color: text('Low');
  }
}
